import React from 'react';
import styles from './safety-limit-tile.scss';
import { SafetyLimitMinValue } from 'app/area/codetable/item/screen-renderer/screen-pickers/safety-limits/safety-limit-min-value';
import { SafetyLimitMaxValue } from 'app/area/codetable/item/screen-renderer/screen-pickers/safety-limits/safety-limit-max-value';
import { SafetyLimitWarningDeviation } from
  'app/area/codetable/item/screen-renderer/screen-pickers/safety-limits/safety-limit-warning-deviation';
import { SafetyLimitTileHeader } from './safety-limit-tile-header';
import { SafetyLimitTileProps, useSafetyLimitTile } from './use-safety-limit-tile';

export type { SafetyLimitTileProps };

export const SafetyLimitTile: React.FC<SafetyLimitTileProps> = (props) => {
  const { updateByKey, resetValidation, codeItem, safetyLimit, translation, validation, readOnlyConfig } = props;
  const {
    updateMinValue, updateMaxValue, updateWarningDeviationPercent,
    remove, readOnly, minValue, maxValue, warningDeviationPercent,
    application, minRequired, maxRequired, errors, hasErrors
  } = useSafetyLimitTile(props);

  return <div className={styles.tileContainer}>
    <div className={`${styles.tile} ${hasErrors && styles.validationErrors}`}>
      <SafetyLimitTileHeader
        title={application?.description}
        errors={errors}
        readOnly={readOnly}
        onRemove={remove}
        removeLabel={translation.remove}
      />
      <ol className={styles.tileContent}>
        <div>
          <div>
            <div className="row">
              <SafetyLimitMinValue
                codeItem={codeItem}
                onChange={updateMinValue}
                resetValidation={resetValidation}
                translation={translation}
                updateByKey={updateByKey}
                value={minValue}
                validation={validation}
                readOnlyConfig={readOnlyConfig}
                safetyLimit={safetyLimit}
                required={minRequired} />
              <SafetyLimitMaxValue
                codeItem={codeItem}
                onChange={updateMaxValue}
                resetValidation={resetValidation}
                translation={translation}
                updateByKey={updateByKey}
                value={maxValue}
                validation={validation}
                readOnlyConfig={readOnlyConfig}
                safetyLimit={safetyLimit}
                required={maxRequired} />
            </div>
          </div>
          <div>
            <div className="row">
              <SafetyLimitWarningDeviation
                codeItem={codeItem}
                onChange={updateWarningDeviationPercent}
                resetValidation={resetValidation}
                translation={translation}
                updateByKey={updateByKey}
                value={warningDeviationPercent}
                validation={validation}
                readOnlyConfig={readOnlyConfig}
                safetyLimit={safetyLimit} />
            </div>
          </div>
        </div>
      </ol>
    </div>
  </div>;
};
